import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=67c3f5cd&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c3f5cd')) {
      api.createRecord('67c3f5cd', component.options)
    } else {
      api.reload('67c3f5cd', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=67c3f5cd&", function () {
      api.rerender('67c3f5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/Chart.vue"
export default component.exports